export default __webpack_public_path__ + "navigation-examples-route-alerts-thumbnail-960-091fe0b335e5626474a475e0102d6981.webp";